export default __webpack_public_path__ + "static/naming-the-action-light-mode-4e3b8c5524b651b3ce83f68afc9a41e6.png";